var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueSlider',_vm._b({ref:"slider",attrs:{"contained":true,"dotSize":1,"height":20,"lazy":false,"railStyle":{
    height: '8px',
  },"tooltip":_vm.tooltip,"tooltipFormatter":_vm.format,"tooltipPlacement":_vm.tooltipPosition,"value":_vm.value},on:{"change":function($event){return _vm.$emit('update:value', $event)}}},'VueSlider',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }